import { Serie } from "@nivo/line";
import * as React from "react";
import { SvcGraphTestData } from "../SvcAnalysisScreen";
import { SvcVolumeTimeGraph } from "./SvcVolumeTimeGraph";
import { SvcVolumeGraph } from "./SvcVolumeGraph";
import Alert, { AlertCategoryEnum } from "../../../misc/components/Alert";
import { BarDatum } from "@nivo/bar";

interface SvcGraphsProps {
    volumeChartData: SvcGraphTestData[];
    volumeTimeChartData: SvcGraphTestData[];
    tZeroAdjust: boolean;
}

export const SvcGraphs = ({ volumeChartData, volumeTimeChartData, tZeroAdjust }: SvcGraphsProps) => {
    const volumeValues = volumeTimeChartData.flatMap(t => t.VolumeData.map(vd => vd.Volume));

    const volumeMin = Math.min(...volumeValues);
    const volumeMax = Math.max(...volumeValues);

    const sortedData = volumeTimeChartData
        .filter(x => x.IsDisplayed)
        .sort((a, b) => a.TestNumber - b.TestNumber);

    const dataKey: keyof (SvcGraphTestData) = tZeroAdjust ? "TZeroAdjustedData" : "VolumeData";

    const vChartData: BarDatum[] = sortedData
        .map(d => ({
            id: d.TestNumber + '',
            key: `Test ${d.TestNumber}`,
            color: d.ColorHex,
            value: d.Vc.toFixed(2),
        }));

    const vTChartData: Serie[] = sortedData
        .map(d => ({
            id: `Test ${d.TestNumber}`,
            color: d.ColorHex,
            data: d[dataKey].map(vd => ({
                x: vd.Time,
                y: vd.Volume
            }))
        })).reverse();

    const specificTimePeriod: number[] = vTChartData.flatMap(t => t.data.map(d => d.x)) as number[];
    const timeMin = Math.min(...specificTimePeriod);
    const timeMax = Math.max(...specificTimePeriod);

    if (sortedData.length === 0)
        return <Alert show={true} category={AlertCategoryEnum.Info}>There are no tests currently selected for display</Alert>

    return (
        <>
            <div data-automationid="VolumeChartWrapper" className="col-md-6" style={{ height: 600 + 'px' }}>
                <h4>Volume Graph</h4>
                <SvcVolumeGraph data={vChartData} maxVolume={volumeMax}/>
            </div>
            <div data-automationid="VolumeTimeChartWrapper" className="col-md-6" style={{ height: 600 + 'px' }}>
                <h4>Volume / Time Graph</h4>
                <SvcVolumeTimeGraph data={vTChartData} minVolume={volumeMin} maxVolume={volumeMax} minTime={timeMin} maxTime={timeMax} />
            </div>
        </>
    );
}
